import React, {  } from 'react'
import { useFormik } from "formik";
import { connect, useSelector } from "react-redux";

//Acciones redux
import { createFranchise } from "../../actions/franchiseeActions";
import RequestFranchisee from '../../containers/Requests/RequestEcoTiendaOrMaster/RequestEcoTiendaOrMaster';
import { Translate } from '../../language';
import { useHistory } from "react-router-dom";

//Componetnes
//import { Places } from "../../../components/form/Places";
import * as Yup from 'yup';

function RegisterForm({
  //Funcion Redux
  createFranchise,
  ...props
}) {
  const history = useHistory();

  // const {logging} = useSelector((state) => state.auth.login)
  const { userInfo } = useSelector(state => state.userInfo)
  const validate = (values) => {
    const errors = {};
    return errors;
  };
  const validationSchema = Yup.object().shape({
    chamberOfCommerce: Yup.mixed().when(['kindOfPerson'], (kindOfPersonValue, schema) => {
      return schema.test("fileSize", "Requerido", (value) => {
        if (kindOfPersonValue ==='natural') {
          return true;
        }
        else {
          if (value && value.type) {
            return value.type.includes('pdf')
          } else {
            return false;
          }
        }

      })
    }),
    bankCertification: Yup.mixed().when(['kindOfPerson'], (kindOfPersonValue, schema) => {
      return schema.test("fileSize", "Requerido", (value) => {
        if (kindOfPersonValue ==='natural') {
          return true;
        }
        else {
          if (value && value.type) {
            return value.type.includes('pdf')
          } else {
            return false;
          }
        }

      })
    }),
    rut: Yup.mixed().when(['kindOfPerson'], (kindOfPersonValue, schema) => {
      return schema.test("fileSize", "Requerido", (value) => {
        if (kindOfPersonValue ==='natural') {
          return true;
        }
        else {
          if (value && value.type) {
            return value.type.includes('pdf')
          } else {
            return false;
          }
        }

      })
    }),

    kindOfPerson: Yup.string().required('Requerido'),
    businessEmail: Yup.string().required('Requerido'),
    businessPhone: Yup.string().required('Requerido'),
    reasonForRequest: Yup.string().required('Requerido'),
    socialReason: Yup.string().required('Requerido'),

    businessCountry: Yup.string().required('Requerido'),
    businessDepartment: Yup.string().required('Requerido'),
    businessCity: Yup.string().required('Requerido'),

    businessLocation: Yup.string().required('Requerido'),
    businessAddress: Yup.string().required('Requerido'),
    picture: Yup.string().required("Es requerido"),
  });

  const formik = useFormik({
    validationSchema,
    initialValues: {
      kindOfPerson: 'natural',
      businessEmail: '',
      businessPhone: '',
      reasonForRequest: '',
      socialReason: '',
      rut: '',
      chamberOfCommerce: '',
      bankCertification: '',
      commercialReference: '',
      businessCountry: 'Colombia',
      businessDepartment: '',
      businessCity: '',
      businessLocation: '',
      businessAddress: '',
      reasonForRequest: '',
      // identificationNumber: '',
    },
    onSubmit: (values) => {
      const formData = new FormData();
      
      for (var key in values) {
        formData.append(key, values[key]);
      }
      createFranchise(formData,history)
      
    },

  });
  return <RequestFranchisee tittle={Translate('requestFranchisee', 'es')}  isEcoTienda={!true} formik={formik} />

}

export default connect(null, { createFranchise })(RegisterForm);
